<template>
	<div class="blockSpacList">
		<div v-for="(item, index) in list" :key="index">
			<el-row type="flex" class="blocK-list" :style="lineStyle">
				<el-col v-for="(e, index) in item" :key="index" :span="24 / item.length">
					<span
						:class="[labelPosition == 'right' ? 'label-right' : null, 'label-position']"
						:style="{ width: labelWidth }"
						>{{ e.label }}</span
					>
					<span class="clearance"></span>
					<component
						:is="e.type"
						class="value"
						v-bind="e"
						v-on="$listeners"
						v-if="e.type"
					></component>

					<el-tooltip effect="dark" :content="e.value" placement="top" v-else-if="e.valueWidth">
						<span class="value" :style="{ width: e.valueWidth }">{{ e.value || '-' }}</span>
					</el-tooltip>
					<span class="value" v-else :style="{ width: e.valueWidth }">{{ e.value || '-' }}</span>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
export default {
	name: 'blockSpacList',
	props: {
		// label位置
		labelPosition: {
			type: String,
			default: 'right',
		},
		list: {
			type: Object,
		},
		// label宽度
		labelWidth: {
			type: String,
		},
		valueWidth: {
			type: String,
		},
		lineStyle: {
			type: Object,
		},
	},
};
</script>
<style scoped lang="scss">
.blockSpacList {
	position: relative;
	.el-col-24 > div {
		display: inline-block;
	}
	.label-position,
	.clearance {
		display: inline-block;
	}
	.label-right {
		text-align: right;
		width: 50%;
	}
	.blocK-list {
		padding: 5px 0px;
	}
	.value {
		width: 50%;
		display: inline-block;
		word-wrap: break-word;
	}
	.blocK-list > div {
		display: flex;
	}
	.clearance {
		width: 20px;
	}
}
</style>
